import { render } from "./ClassInfo.vue?vue&type=template&id=3bd56716&scoped=true"
import script from "./ClassInfo.vue?vue&type=script&lang=js"
export * from "./ClassInfo.vue?vue&type=script&lang=js"

import "./ClassInfo.vue?vue&type=style&index=0&id=3bd56716&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd56716"]])

export default __exports__